import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environment/environment';
import { WorkspaceDetailsDto, WorkspaceDto } from '../models/workspaces.model';

@Injectable({
  providedIn: 'root',
})
export class WorkspacesApiService extends ApiService {
  constructor() {
    super();
  }

  getWorkspaces$(): Observable<WorkspaceDto[]> {
    return this.get('/workspaces');
  }

  createWorkspace$(
    name: string,
    metadata: WorkspaceCreateRequestMetadata[],
  ): Observable<WorkspaceDto> {
    return this.post('/workspaces', { name, metadata });
  }

  renameWorkspace$(name: string, uniqId: string): Observable<WorkspaceDto> {
    return this.post(`/workspaces/${uniqId}`, { name });
  }

  getWorkspaceDetails$(uniqId: string): Observable<WorkspaceDetailsDto> {
    return this.get(`/workspaces/${uniqId}`);
  }

  deleteWorkspace$(uniqueId: string, keepDocuments: boolean = true): Observable<any> {
    return this.delete(`/workspaces/${uniqueId}?keepDocuments=${keepDocuments}`);
  }

  addDocumentToWorkspace$(
    id: string,
    metadata: WorkspaceCreateRequestMetadata[],
  ): Observable<WorkspaceDto> {
    return this.post(`/workspaces/${id}/documents`, { metadata });
  }

  unlinkWorkspaceDocument$(uniqueId: string, documentId: string): Observable<any> {
    return this.delete(`/workspaces/${uniqueId}/documents/${documentId}`);
  }
}

export interface WorkspaceCreateMetadata {
  documentTypeId: number;
  languageId: number;
  positionId: number;
}

export interface WorkspaceCreateRequestMetadata extends WorkspaceCreateMetadata {
  fileId: string;
}

export const apiWorkspacesProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiWorkspaces.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiWorkspaces.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiWorkspaces.scopes.write],
  },
  {
    httpMethod: 'DELETE',
    scopes: [...environment.protectedResources.apiWorkspaces.scopes.write],
  },
];
